import { Outlet, useLocation } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';
import Breadcrumbs from '../Breadcrumbs';
import BackToTop from '../BackToTop';
import ReadingProgress from '../ReadingProgress';
import RouteAnnouncer from '../RouteAnnouncer';

const ChatWidget = lazy(() => import('../ChatWidget'));

export default function Layout() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col">
      <RouteAnnouncer />
      <ReadingProgress />
      <Header />
      <Breadcrumbs />
      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          id="main-content"
          className="flex-1"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
        >
          <Outlet />
        </motion.main>
      </AnimatePresence>
      <Footer />
      <BackToTop />
      <Suspense fallback={null}>
        <ChatWidget />
      </Suspense>
    </div>
  );
}
